import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import BsyDashBase from "../BsyDashBase";
import BsyDash from "../../dash/BsyDash";
import { BsyUtils } from "../../../../src/utils/Utils";
import "./index.css";
import classNames from "classnames";
import { WindowPropsContext, windowProp } from "../component_context.js";

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
class BsyDashBaseLayoutContainer extends BsyDashBase {
  static contextType = WindowPropsContext;
  constructor(props) {
    console.log(
      props.allComponentDash.entry.styles.widget.fontSetting.titleColor
    );
    super(props);
    this.state = {
      mode: props.mode,
      dashConfig: {}, //需要传给公共组件的对象
      containerComponentsModel: props.containerComponentsModel, //容器自身属性
      allComponentDash: JSON.parse(
        JSON.stringify(props.allComponentDash.entry.components)
      ), //所有组件
      entry: JSON.parse(JSON.stringify(props.allComponentDash.entry)),
      isShowUpdata: false, //下拉框显示
      tabListActiveIndex: props.containerComponentsModel.tabListActiveIndex,
      leftUpDownData: [], //左下拉数据
      rightUpDownData: [], //右下拉数据
      componentsList: [], //tab切换组成全部数据
      titleColor:
        props.allComponentDash.entry.styles.widget.fontSetting.titleColor,
      // style={{color:this.props.allComponentDash.styles.widget.fontSetting.titleColor}}
      // widgetsMap: props.widgetsMap,
    };
    this.ulRefElement = React.createRef();
    this.tabListElement = React.createRef();
    this.tpcContainerComponents = React.createRef();
    this.timeInter = null;
    this.oldSubsidiaryTab = []; //用于tab第一次加载，第二次不刷新的辅助变量
  }
  componentDidMount() {
    var isbur = false;

    if (this.props.getContext) {
      this.props.getContext(this);
    }
    var componentsList = [];
    if (this.state.containerComponentsModel.isOpenTabList) {
      //打开tab栏
      var dashConfig = JSON.parse(JSON.stringify(this.state.entry));
      BsyUtils.forEach(
        this.state.containerComponentsModel.tabList,
        (key, item) => {
          this.oldSubsidiaryTab.push(null);
          var dashConfig = this.initTablistShowLogicFn(key);
          componentsList.push(dashConfig);
        }
      );
      this.ulRefElement.current.scrollWidth >
        this.tabListElement.current.scrollWidth
        ? (isbur = true)
        : (isbur = false);
      this.oldSubsidiaryTab[0] = "0a";
      this.setState({
        componentsList: componentsList,
        tabListActiveIndex: 0,
        isShowUpdata: isbur,
      });
    } else {
      var Config = JSON.parse(JSON.stringify(this.state.entry));
      var co = Object.fromEntries(
        Object.entries(this.state.allComponentDash).filter(([key, val]) => {
          return val["parentsId"] && val["parentsId"] === this.props.widgetId;
        })
      );
      Config.components = co;
      this.setState({
        dashConfig: Config,
      });
    }
    if (this.state.containerComponentsModel.isOpenAutomaticWheelSeeding) {
      //自动轮播
      this.timeInter = setInterval(() => {
        let allIsload = []; //加载完成后才执行切换动作
        var co = Object.fromEntries(
          Object.entries(
            this.context.getOverallSituationValue("widgetsMap")
          ).filter(([key, val]) => {
            return val["parentsId"] && val["parentsId"] === this.props.widgetId;
          })
        );
        BsyUtils.forEach(co, function (key, item) {
          if (
            [
              "base_layout_container",
              "description",
              "image",
              "gauge_imageMore",
              "embedded_iframe",
              "real_time",
            ].indexOf(item.state.widget.type) <= -1 &&
            item.state.widget.type.indexOf("filter") <= -1
          ) {
            if (
              item.isWidgetLoaded() &&
              this._checkFieldsValid(item.state.widget)
            ) {
              allIsload.push(true);
            } else {
              if (!this._checkFieldsValid(item.state.widget)) {
                allIsload.push(true);
              } else {
                console.log("不起效的组件", item.state.widget);
                allIsload.push(false);
              }
            }
          }
        });
        if (
          allIsload.every((item) => {
            return item;
          })
        ) {
          var tabListActiveIndex = this.state.tabListActiveIndex + 1;

          if (
            tabListActiveIndex >=
            this.state.containerComponentsModel.tabList.length
          ) {
            tabListActiveIndex = 0;
          }
          this.setTabActFn(tabListActiveIndex);
        }
      }, this.state.containerComponentsModel.intervalBetweenRotations * 1000);
    }
    this._bindWheelEvent();
  }

  componentWillUnmount() {
    if (this.timeInter) clearInterval(this.timeInter);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.isDashFull !== this.isDashFull)
      this.isDashFull = nextProps.isDashFull;
  }
  getWidgetByName = (t) => {
    return this.context.getOverallSituationValue("widgetsMap")[t];
  };
  setTabActFn = (index, ev) => {
    let that = this;
    this.setState(
      {
        tabListActiveIndex: Number(index),
      },
      () => {
        // 懒加载的时候，容器多标签会导致某些组件没有更新，需要手动重新触发一次
        that.bsyDashContext?.[Number(index)]?.lazyLoad?.();
        // 
        // let arr = this.state.containerComponentsModel.tabList[index].children;
        // BsyUtils.forEach(arr, function (key, item) {

        //   const components = that.getWidgetByName(item)
        //   console.log(components);
        //   if (components.componentContext.doResize) {
        //     components.componentContext.doResize();
        // }
        // });

        // if (this.oldSubsidiaryTab[index]) {
        //   BsyUtils.forEach(this.props.widgetsMap, (key, item) => {
        //     let arr = this.state.containerComponentsModel.tabList[index].children;
        //     if (arr.indexOf(item.state.widget.widgetId) >= 0) {
        //       //只刷新当前tab中的组件
        //       // item.componentContext &&
        //       //   item.componentContext.doResize &&
        //       //   item.componentContext.doResize();
        //       if (
        //         this.bsyDashContext[index] &&
        //         this.bsyDashContext[index].doResize
        //       ) {
        //         this.bsyDashContext[index].doResize();
        //       }
        //     }
        //   });
        // }
        this._headSlideFn(index);
      }
    );
    this.oldSubsidiaryTab[index] = index + "a";
  };
  _headSlideFn = (index) => {
    let listTab = window
      .$(this.tpcContainerComponents.current)
      .find(".t-li-tab");
    if (this.ulRefElement.current && listTab.length >= 1) {
      this.ulRefElement.current.scrollLeft =
        listTab.eq(index)[0].offsetLeft -
        this.tabListElement.current.scrollWidth / 2 +
        listTab.eq(index)[0].scrollWidth / 2;
    }
  };

  setAutoLoad = (auto) => {
    BsyUtils.forEach(this.bsyDashContext, (i, widget) => {
      widget && widget.setAutoLoad && widget.setAutoLoad(auto);
    });
  };

  // 取最左侧的tab下标
  _getNextTabWidth = () => {
    const left = this.ulRefElement.current.scrollLeft;
    let li_width_sum = 0;
    let next_width = 0;
    let next_text = "";
    BsyUtils.forEach(
      this.ulRefElement.current.querySelectorAll("li"),
      function (index, el) {
        next_width = el.offsetWidth;
        next_text = el.innerText;
        if (li_width_sum > left) {
          return false;
        }
        li_width_sum = li_width_sum + next_width + 26;
      }
    );
    console.log("_getNextTabWidth", next_text, next_width, li_width_sum);
    return li_width_sum;
  };
  _getForwardTabWidth = () => {
    const left = this.ulRefElement.current.scrollLeft;
    console.log("_getForwardTabWidth", left);
    let li_width_sum = 0;
    let forward_width = 0;
    let forward_text = "";
    let last_width = 0;
    BsyUtils.forEach(
      this.ulRefElement.current.querySelectorAll("li"),
      function (index, el) {
        forward_width = el.offsetWidth;
        forward_text = el.innerText;

        if (li_width_sum >= left) {
          li_width_sum = li_width_sum - last_width;
          return false;
        }

        if (li_width_sum + forward_width > left) {
          return false;
        }
        last_width = forward_width + 26;
        li_width_sum = li_width_sum + last_width;
      }
    );
    console.log(
      "_getForwardTabWidth",
      forward_text,
      forward_width,
      li_width_sum
    );
    return li_width_sum;
  };
  _bindWheelEvent = () => {
    let that = this;
    let timer = null;
    window.$(this.ulRefElement.current).off("wheel");
    window.$(this.ulRefElement.current).on("wheel", function (event) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        if (event.originalEvent.deltaY > 0) {
          console.log("Scrolling down");
          event.currentTarget.scrollLeft = that._getNextTabWidth();
        } else {
          console.log("Scrolling up");
          event.currentTarget.scrollLeft = that._getForwardTabWidth();
        }
      }, 100);

      return false;
    });
  };

  enterLeftUpDownFn = () => {
    var leftList = [];
    BsyUtils.forEach(
      document.getElementsByClassName("t-li-tab"),
      (index, item) => {
        if (
          window.$(item).offset().left + 8 <
          window.$(this.tabListElement.current).offset().left
        ) {
          leftList.push({
            title: window.$(item).text(),
            index: window.$(item).attr("index"),
            minWidth: window.$(item).innerWidth() + 26, //26为margin值
          });
        }
      }
    );
    this.setState({
      leftUpDownData: leftList,
    });
  };
  clickLeftUpDownFn = () => {
    this.ulRefElement.current.scrollLeft = 0;
  };
  clickRightUpDownFn = () => {
    this.ulRefElement.current.scrollLeft = 100000;
  };
  enterRightUpDownFn = () => {
    var rightList = [];
    BsyUtils.forEach(
      document.getElementsByClassName("t-li-tab"),
      (index, item) => {
        if (
          window.$(item).offset().left + 8 >
          window.$(this.tabListElement.current).offset().left +
          window.$(this.tabListElement.current).innerWidth()
        ) {
          rightList.push({
            title: window.$(item).text(),
            index: window.$(item).attr("index"),
            minWidth: window.$(item).innerWidth() + 26, //26为margin值
          });
        }
      }
    );
    this.setState({
      rightUpDownData: rightList,
    });
  };
  leaveLeftUpDownFn() {
    this.setState({
      leftUpDownData: [],
    });
  }
  leaveRightUpDownFn = () => {
    this.setState({
      rightUpDownData: [],
    });
  };
  initTablistShowLogicFn = (index) => {
    var dashConfig = this.state.entry;
    let objRes = {};
    let arr = this.state.containerComponentsModel.tabList[index].children;
    let course = this.state.allComponentDash;
    BsyUtils.forEach(arr, (key, item) => {
      course[item] && (objRes[item] = course[item]);
    });
    dashConfig = { ...dashConfig, components: objRes };
    return dashConfig;
  };
  loadData = (n, d) => {
    BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
  };

  // 用于 doReSize使用
  getDashContext = (context, index) => {
    if (!this.bsyDashContext) {
      this.bsyDashContext = [null];
    }
    if (index === this.bsyDashContext.length - 1) {
      this.bsyDashContext.push(null);
    }
    this.bsyDashContext[index] = context;
  };

  doResize = () => {
    let that = this
    // const { tabListActiveIndex = 0 } = this.state;
    // console.log(this.bsyDashContext)
    // console.log(tabListActiveIndex)

    // if (
    //   this.bsyDashContext[tabListActiveIndex] &&
    //   this.bsyDashContext[tabListActiveIndex].doResize
    // ) {
    //   this.bsyDashContext[tabListActiveIndex].doResize();
    // }
    let arr = this.state.containerComponentsModel.tabList;
    BsyUtils.forEach(arr, function (key, item) {
      console.log(key);
      if (that.bsyDashContext[key] && that.bsyDashContext[key].doResize) {
        that.bsyDashContext[key].doResize();
      }
    });
  };
  _checkFieldsValid = (t) => {
    if (BsyUtils.isObjectEmpty(t)) return !1;
    let e = !0;
    switch (t.type) {
      case "line_chart":
      case "column_chart":
      case "bar_chart":
      case "funnel_chart":
      case "area_chart":
      case "radar_chart":
      case "pie_chart":
      case "map_chart":
        e =
          (t.xFields.length > 0 || t.yFields.length > 0) &&
          t.metrics.length > 0;
        break;
      case "pivot_table":
        e =
          t.xFields.length > 0 || t.yFields.length > 0 || t.metrics.length > 0;
        break;
      case "multi_axes_chart":
        e = t.xFields.length > 0 && t.metrics.length > 0;
        break;
      case "metric_table":
      case "gauge_chart":
        e = t.metrics.length > 0;
        break;
      case "data_table":
      case "rili":
      case "newrili":
        e = t.fields && t.fields.length > 0;
        break;
      default: {
      }
    }
    return e;
  };

  render() {
    return (
      <div
        ref={this.tpcContainerComponents}
        className={classNames(
          this.state.containerComponentsModel.isDisplayTitle ||
            this.state.containerComponentsModel.isOpenTabList
            ? "t-pc-container-components"
            : "t-pc-container-components no-title"
        )}
      >
        {this.state.containerComponentsModel.isOpenTabList ? (
          <>
            <div className="t-pc-tabList" ref={this.tabListElement}>
              <ul
                className={this.state.containerComponentsModel.tabType}
                ref={this.ulRefElement}
              >
                {this.state.containerComponentsModel.tabList.map(
                  (item, index) => {
                    return (
                      <li
                        className={
                          index === this.state.tabListActiveIndex
                            ? "tab-header-active t-li-tab"
                            : "t-li-tab"
                        }
                        key={index}
                        index={index}
                        onClick={(event) => {
                          this.setTabActFn(index, event);
                        }}
                      >
                        {item.title}
                        <div class="t-triangle-down"></div>
                      </li>
                    );
                  }
                )}
              </ul>
              {this.state.isShowUpdata && (
                <div
                  className="left-scoll"
                  onMouseEnter={(event) => {
                    this.enterLeftUpDownFn();
                  }}
                  onClick={(event) => {
                    this.clickLeftUpDownFn();
                  }}
                  onMouseLeave={(event) => {
                    this.leaveLeftUpDownFn();
                  }}
                >
                  <span>
                    <i className="icon-angleleft"></i>
                  </span>
                  {this.state.leftUpDownData.length > 0 && (
                    <ul className="t-pc-up-down-left">
                      {this.state.leftUpDownData.map((item, index) => {
                        return (
                          <li
                            key={index}
                            index={item.index}
                            style={{ minWidth: item.minWidth }}
                            onClick={(event) => {
                              this.setTabActFn(item.index, event);
                            }}
                          >
                            {item.title}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              )}
              {this.state.isShowUpdata && (
                <div
                  className="right-scoll"
                  onMouseEnter={(event) => {
                    this.enterRightUpDownFn();
                  }}
                  onClick={(event) => {
                    this.clickRightUpDownFn();
                  }}
                  onMouseLeave={(event) => {
                    this.leaveRightUpDownFn();
                  }}
                >
                  <span>
                    <i className="icon-angleright"></i>
                  </span>
                  {this.state.rightUpDownData.length > 0 && (
                    <ul className="t-pc-up-down-right">
                      {this.state.rightUpDownData.map((item, index) => {
                        return (
                          <li
                            key={index}
                            index={item.index}
                            style={{ minWidth: item.minWidth }}
                            onClick={(event) => {
                              this.setTabActFn(item.index, event);
                            }}
                          >
                            {item.title}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              )}
            </div>
            {this.state.componentsList.map((item, index) => {
              // this.oldSubsidiaryTab[index] &&
              return (
                <div
                  className={classNames(
                    this.state.tabListActiveIndex === index
                      ? "t-dash-box t-dash-box-show"
                      : "t-dash-box"
                  )}
                >
                  <BsyDash
                    key={`dash${item.appId}${item.entryId}`}
                    {...item}
                    isDashFull={this.isDashFull}
                    // widgetsMap={this.props.widgetsMap}
                    widgetsObject={this.props.widgetsObject}
                    widgetsValue={this.props.widgetsValue}
                    globFilter={this.props.globFilter}
                    overallBlocks={this.props.overallBlocks}
                    popupFormPath={this.props.popupFormPath}
                    overalDashList={this.props.overalDashList}
                    overallBlockMap={this.props.overallBlockMap}
                    // refreshMap={this.refreshMap}
                    mode={this.state.mode}
                    // refresWidgetMapTime={this.refresWidgetMapTime}
                    // refreshNewUpdataTime={this.refreshNewUpdataTime}
                    allComponentDash={this.props.allComponentDash}
                    containiershowStyle="base_layout_container"
                    getContext={(context) => {
                      this.getDashContext(context, index);
                    }}
                  />
                </div>
              );
            })}
          </>
        ) : (
          <>
            {this.state.containerComponentsModel.isDisplayTitle && (
              <div
                className="t-pc-tabList"
                style={{ borderBottom: "1px solid #e6e6e6" }}
              >
                <div
                  className="t-pc-block-title"
                  style={{ color: this.state.titleColor }}
                >
                  {this.state.containerComponentsModel.title}
                </div>
              </div>
            )}
            <div className="t-dash-box t-dash-box-show">
              <BsyDash
                key={`dash${this.state.dashConfig.appId}${this.state.dashConfig.entryId}`}
                {...this.state.dashConfig}
                isDashFull={this.isDashFull}
                // widgetsMap={this.props.widgetsMap}
                widgetsObject={this.props.widgetsObject}
                widgetsValue={this.props.widgetsValue}
                globFilter={this.props.globFilter}
                popupFormPath={this.props.popupFormPath}
                overallBlocks={this.props.overallBlocks}
                overalDashList={this.props.overalDashList}
                overallBlockMap={this.props.overallBlockMap}
                allComponentDash={this.props.allComponentDash}
                // refreshMap={this.refreshMap}
                mode={this.state.mode}
                // refresWidgetMapTime={this.refresWidgetMapTime}
                // refreshNewUpdataTime={this.refreshNewUpdataTime}
                containiershowStyle="base_layout_container"
                getContext={(context) => {
                  this.getDashContext(context, 0);
                }}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}

BsyDashBaseLayoutContainer.propTypes = propTypes;
BsyDashBaseLayoutContainer.defaultProps = defaultProps;
BsyDashBaseLayoutContainer.contextType = WindowPropsContext;
// #endregion

export default BsyDashBaseLayoutContainer;
